const VISIBLE_SLOTS = 4

export function scrollCounter() {
	document.querySelectorAll('.has-scroll-counter [data-scroll-counter]').forEach((wrapper) => {
		const section = wrapper.closest('.has-scroll-counter')
		const track = wrapper.querySelector('[data-scroll-counter-track]')
		const items = Array.from(wrapper.querySelectorAll('[data-scroll-counter-item]'))
		const staged = items.slice(2)

		if (!section || !track || !staged.length) return

		function update() {
			const total = section.offsetHeight - window.innerHeight
			const scrolled = Math.min(Math.max(-section.getBoundingClientRect().top, 0), total)
			const progress = total > 0 ? scrolled / total : 1
			const windowShift = 1 / (2 * staged.length)

			let revealSum = 0

			staged.forEach((item, index) => {
				const start = index / staged.length - windowShift
				const end = (index + 1) / staged.length - windowShift
				const reveal = Math.min(Math.max((progress - start) / (end - start), 0), 1)
				item.style.setProperty('--reveal', reveal)
				revealSum += reveal
			})

			const itemHeight = items[0].getBoundingClientRect().height
			const overflowItems = Math.max(0, revealSum - (VISIBLE_SLOTS - 2))

			wrapper.style.height = `${itemHeight * VISIBLE_SLOTS}px`
			track.style.transform = `translateY(${-overflowItems * itemHeight}px)`
		}

		update()
		window.addEventListener('scroll', update, { passive: true })
		window.addEventListener('resize', update)
	})
}
